import { TGetLimitUrlResponse, TOrderResponse } from '@/screens/PersonalOrders/page/model/types/types'

import { apiSlice } from '@/shared/api/apiSlice'
import { API_URL } from '@/shared/lib/const/env'
import { PERSONAL_API } from '@/shared/lib/utils/constants/const'
import { ServerResponse } from '@/shared/types/common'

import { OrderPayloadTypes, User, UserBonuses, UserLimitBalance, UserSubscription } from '../model/types/UserSchema'

// NOTE: use full endpoint path to override default RTK Query baseURL
// Example: ${PERSONAL_API}/some-endpoint

export const userApiSlice = apiSlice.injectEndpoints({
	endpoints: builder => ({
		getUserData: builder.query<ServerResponse<User>, void>({
			query: () => `${PERSONAL_API}/v1/personal/user`
		}),
		getUserSubscription: builder.query<ServerResponse<UserSubscription[]>, void>({
			query: () => `${PERSONAL_API}/v1/user/subscription`
		}),
		getUserBonuses: builder.query<ServerResponse<UserBonuses>, void>({
			query: () => `${PERSONAL_API}/v1/user/bonus`
		}),
		getUserOrder: builder.query<TOrderResponse, OrderPayloadTypes>({
			query: (payload: OrderPayloadTypes) => ({
				url: `${PERSONAL_API}/v1/individual/user/order`,
				params: {
					filter: JSON.stringify(payload)
				}
			})
		}),
		getLimitBalance: builder.query<ServerResponse<UserLimitBalance>, void>({
			query: () => `${API_URL}/payment/limit/balance`
		}),
		getLimitUrl: builder.query<ServerResponse<TGetLimitUrlResponse>, any>({
			query: () => `${API_URL}/payment/limit/url`
		}),
		updateUserData: builder.mutation({
			query: (body: User) => ({
				url: `${PERSONAL_API}/v1/personal/user`,
				method: 'PUT',
				headers: {
					'Content-Type': 'application/json'
				},
				body: JSON.stringify(body)
			})
		}),
		updateSubscriptionPreferencies: builder.mutation({
			query: (body: { subscriptions: UserSubscription[] }) => ({
				url: `${PERSONAL_API}/v1/user/subscription`,
				method: 'PUT',
				headers: {
					'Content-Type': 'application/json'
				},
				body: JSON.stringify(body)
			})
		}),
		deleteUserAccount: builder.mutation<void, void>({
			query: () => ({
				url: `${PERSONAL_API}/v1/personal/user`,
				method: 'DELETE'
			})
		})
	})
})

export const {
	useGetUserDataQuery,
	useGetUserSubscriptionQuery,
	useGetUserBonusesQuery,
	useUpdateUserDataMutation,
	useUpdateSubscriptionPreferenciesMutation,
	useDeleteUserAccountMutation,
	useGetUserOrderQuery,
	useLazyGetUserOrderQuery,
	useGetLimitBalanceQuery,
	useLazyGetLimitUrlQuery
} = userApiSlice
